import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThLarge, faShareAlt, faUserTie } from '@fortawesome/free-solid-svg-icons';
import { userSelector } from '../../redux/selectors/system/user-selector';
import { configSelector } from '../../redux/selectors/system/config-selector';
import { User } from '../../types/state';
import { Config } from '../../types/config/config';
import AdminHeader from './admin-header';
import AdminDashboardTab from './tabs/admin-dashboard-tab';
import AdminThirdPartyPublishingTab from './tabs/admin-third-party-publishing-tab';
import AdminBrokerWorkflowTab from './tabs/admin-broker-workflow-tab'

type AdminTab = 'dashboard' | 'third-party-publishing' | 'broker-workflow';

const AdminContainer: FC = (props) => {

    const user: User = useSelector(userSelector);
    const config: Config = useSelector(configSelector);
    const [activeTab, setActiveTab] = useState<AdminTab>('dashboard');

    let isThirdPartyPublishingEnabled = false;
    if (config && config.featureFlags && config.featureFlags.adminThirdPartyPublishingEnabled) {
        isThirdPartyPublishingEnabled = true;
    }

    let isBrokerWorkflowEnabled = false;
    if (config && config.featureFlags && config.featureFlags.adminBrokerWorkflowEnabled) {
        isBrokerWorkflowEnabled = true;
    }
    const TABS: Array<{ id: AdminTab; label: string; icon: any }> = [];
    TABS.push({ id: 'dashboard', label: 'Dashboard', icon: faThLarge });
    if (isThirdPartyPublishingEnabled) {
        const tab: { id: AdminTab; label: string; icon: any } = { id: 'third-party-publishing', label: 'Third Party Sites', icon: faShareAlt };
        TABS.push(tab);
    }
    if (isBrokerWorkflowEnabled) {
        const brokerWorkflowTab: { id: AdminTab; label: string; icon: any } = { id: 'broker-workflow', label: 'Broker Workflow', icon: faUserTie };
        TABS.push(brokerWorkflowTab);
    }
    return (
        <div>
            { user && user.isAdmin &&
                <div>
                    <AdminHeader />
                    <Layout>
                        <Sidebar>
                            <SidebarList>
                                {TABS.map(tab => (
                                    <TabItem
                                        key={tab.id}
                                        active={activeTab === tab.id}
                                        onClick={() => setActiveTab(tab.id)}
                                    >
                                        <TabIconWrap active={activeTab === tab.id}>
                                            <FontAwesomeIcon icon={tab.icon} />
                                        </TabIconWrap>
                                        <TabLabel active={activeTab === tab.id}>{tab.label}</TabLabel>
                                    </TabItem>
                                ))}
                            </SidebarList>
                        </Sidebar>
                        <Content>
                            {activeTab === 'dashboard' && <AdminDashboardTab />}
                            {activeTab === 'third-party-publishing' && <AdminThirdPartyPublishingTab />}
                            {activeTab === 'broker-workflow' && <AdminBrokerWorkflowTab />}
                        </Content>
                    </Layout>
                </div>
            }
            { (!user || !user.isAdmin) && <div>Sorry, these are not the droids you are looking for...</div>}
        </div>
    );
};

const Layout = styled.div`
    display: flex;
    min-height: calc(100vh - 60px);
    background: #ffffff;
`;

const Sidebar = styled.nav`
    width: 280px;
    flex-shrink: 0;
    background: #ffffff;
    border-right: 1px solid #e4e7eb;
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    box-shadow: -1px 0 0 rgba(0,0,0,0.02);
`;

const SidebarList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    gap: 14px;
`;

const TabItem = styled.li<{ active: boolean }>`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 2px 16px;
    min-height: 50px;
    border-radius: 8px;
    border: 1px solid transparent;
    cursor: pointer;
    user-select: none;
    background: ${props => props.active ? '#d6dddc' : 'transparent'};
    transition: background 140ms;

    &:hover {
        background: ${props => props.active ? '#d6dddc' : '#f2f5f4'};
    }
`;

const TabIconWrap = styled.span<{ active: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.05rem;
    color: ${props => props.active ? '#0c5a45' : '#1f7a5d'};
    flex-shrink: 0;
    transition: color 140ms;
`;

const TabLabel = styled.span<{ active: boolean }>`
    font-family: 'Futura Md BT', helvetica, arial, sans-serif;
    font-size: 1rem;
    font-weight: ${props => props.active ? '700' : '600'};
    color: ${props => props.active ? '#0c5a45' : '#1f7a5d'};
    line-height: 1.25;
    transition: color 140ms;
`;

const Content = styled.div`
    flex: 1;
    overflow: auto;
    background: #ffffff;
`;

export default AdminContainer;

